<template>
  <div class="container">
    <div class="centerTop">
      <div style="margin-bottom: 10px">
        选择主题：
        <a-select show-search allowClear placeholder="请选择" class="margin_self" v-model="value" style="width: 200px" @change="change">
          <a-select-option v-for="(item, index) in themeList" :key="index" :value="item.value">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </div>
      <!-- 主题颜色 -->
      <div style="margin-bottom: 10px">
        主题颜色:
        <a-input
          placeholder="请选择"
          type="color"
          style="width: 200px; displsy: inline-block; margin-left: 10px"
          v-model="color"
        />
      </div>
      <!-- pc端登陆背景 -->
      <div><h2>pc端:</h2></div>
      <div class="box">
        <div class="boxItem" v-for="(item, index) in pcImg" :key="index">
          <div class="itemUp">
            <div class="itemMar"></div>
            <div class="itemCen">
              <div class="itemMor">
                <i class="upIco">+</i>
                <input ref="file" id="pc" type="file" class="fileUp" @change="uploadImage($event, index)" />
                <div class="itemImg" v-if="item.img">
                  <div class="imgBox">
                    <div class="bg">
                      <a-icon class="deleteIcon" type="delete" @click="deleteImage($event, index)" />
                    </div>
                    <img class="imgShow" :src="item.img" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">{{item.title}}</div>
        </div>
      </div>
      <!-- 移动端登陆背景 -->
      <div><h2>移动端:</h2></div>
      <div class="box">
        <div class="boxItem" v-for="(item, index) in acrondImg" :key="index">
          <div class="itemUp">
            <div class="itemMar"></div>
            <div class="itemCen">
              <div class="itemMor">
                <i class="upIco">+</i>
                <input ref="file2" type="file" id="weixin" class="fileUp" @change="uploadImage($event, index)" />
                <div class="itemImg" v-if="item.img">
                  <div class="imgBox">
                    <div class="bg">
                      <a-icon class="deleteIcon" type="delete" @click="deleteImage2($event, index)" />
                    </div>
                    <img class="imgShow" :src="item.img" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">{{item.title}}</div>
        </div>
      </div>
    </div>
      <a-button type="primary" @click="setTheme" style="margin-bottom:15px;float:right;margin-right:15px;"> 设置主题 </a-button>
  </div>
</template>

<script>
import { sys_status_config ,changeConfig} from '@/api/activiti'
export default {
  data() {
    return {
      id: '',
      idIndex: '',
      pcImg: [{
        id: 1,
        title: '登录背景',
        img: '',
      },{
        id: 2,
        title: 'logo',
        img: ''
      }],
      acrondImg: [{
        id: 1,
        title: '登录背景',
        img: '',
      },{
        id: 2,
        title: 'logo',
        img: '',
      },{
        id: 3,
        title: '轮播图1',
        img: '',
      },{
        id: 4,
        title: '轮播图2',
        img: '',
      },{
        id: 5,
        title: '轮播图3',
        img: '',
      },{
        id: 6,
        title: '我的背景',
        img: '',
      }],
      color: '#FC4343',
      img: '',
      value: '',
      themeList: [
        {
          value: 'old',
          title: '默认主题',
        },
        {
          value: 'new',
          title: '节日主题',
        },
      ],
    }
  },
  created() {
    this.changeTheme()
    
  },
  methods: {
    // 设置主题
    setTheme() {
      changeConfig({
        id: this.id,
        filePathName: this.value,
        activeColor: this.color,
      }).then(res => {
        if(res.code==200) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }

      })

    },
    change() {
       this.getImg(this.value)
    },
    // 主题
    changeTheme() {
      sys_status_config().then((res)=> {
        if(res.code == 200) {
          this.value = res.data.filePathName
          this.color = res.data.activeColor
          this.id = res.data.id
          this.getImg(this.value)
        }
        })

    },
    getImg(data) {
          var time = new Date().getTime()
          this.pcImg[0].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/pc/'+ data + '/&fileName=login.png&time=' + time
          this.pcImg[1].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/pc/'+ data + '/&fileName=logo.png&time=' + time
          this.acrondImg[0].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/weixin/'+ data + '/&fileName=login_bg.png&time=' + time
          this.acrondImg[1].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/weixin/'+ data + '/&fileName=logo.png&time=' + time
          this.acrondImg[2].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/weixin/'+ data + '/&fileName=banner.png&time=' + time
          this.acrondImg[3].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/weixin/'+ data + '/&fileName=banner1.png&time=' + time
          this.acrondImg[4].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/weixin/'+ data + '/&fileName=banner2.png&time=' + time
          this.acrondImg[5].img = process.env.VUE_APP_API_BASE_URL + '/file//file/pre_static' + '?path=/weixin/'+ data + '/&fileName=user_bg.png&time=' + time
    },
    //上传文件
    uploadImage(e,index) {
      // this.img = 'https://img2.baidu.com/it/u=548770832,2887070754&fm=253&fmt=auto?w=120&h=80'
      var id = e.currentTarget.getAttributeNode("id").value;
      var name = ''
      var type = ''
       console.log(e, e.target.value,e.target.files,id,index,'eeeeeeeeeeeeeeee')
      if (e.target.value) {
        var file = ''
        if(id === 'pc') {
          file = this.$refs.file[index].files[0]
        } else {
          file = this.$refs.file2[index].files[0]
        }
        e.target.value = ''
        // if (file.size / 1024 / 1024 > 10) {
        //   return this.$message.error('上传文件大小不能超过 10MB!')
        // }
        if (file.type.indexOf('/png') == -1) {
          return this.$message.error('只能上传.png图片文件')
        }
        if(id === 'pc'&& index == 0 ) {
          name = 'login'
          type = '/pc/' + this.value + '/'
        } else if (id === 'pc' && index == 1) {
           name = 'logo'
           type = '/pc/'  + this.value + '/'
        } else if (id === 'weixin' && index == 0) {
           name = 'login_bg'
           type = '/weixin/' + this.value + '/'
        }else if (id === 'weixin' && index == 1) {
          name = 'logo'
          type = '/weixin/'  + this.value + '/'
        }else if (id === 'weixin' && index == 2) {
          name = 'banner'
          type = '/weixin/'  + this.value + '/'
        }else if (id === 'weixin' && index == 3) {
          name = 'banner1'
          type = '/weixin/'  + this.value + '/'
        }else if (id === 'weixin' && index == 4) {
          name = 'banner2'
          type = '/weixin/'  + this.value + '/'
        } else if (id === 'weixin' && index == 5) {
          name = 'user_bg'
          type = '/weixin/'  + this.value + '/'
        }
        this.upload(file,name,type).then((res) => {
          console.log(res,this.acrondImg, 'res=====================')
          // this.formData.uuid = this.timeTemp
          // this.imgUrl.push({ preUrl: res.data.url[0].url })
        })
      }
    },
    upload(file,name,type) {
      let params = new FormData()
      params.append('file', file)
      params.append('name', name)
      params.append('type', type)
      axios.defaults.headers['token'] = localStorage.getItem('Access-Token').replace(/"/g, '')
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_API_BASE_URL + '/file/fileNew/uploadNewAndOld',
          method: 'post',
          data: params,
        }).then((res) => {
            this.pcImg.forEach(item => {
              item.img = ''
            })
            this.acrondImg.forEach(item => {
              item.img = ''
            })
            this.$nextTick(()=> {
              this.getImg(this.value)
            })
          console.log(this.pcImg[0].img , 'this.pcImg[0].img ========================')
          resolve(res.data)
          
        })
      })
    },
    deleteImage(e,index) {
      this.pcImg[index].img = ''
    },
    deleteImage2(e,index) {
      this.acrondImg[index].img = ''
    },
  },
}
</script>

<style lang='less'>
.centerTop {
  padding: 10px;
}
.box {
  width: 100%;
  float: left;
  padding-bottom: 15px;
  .boxItem {
    width: 19%;
    float: left;
    margin-right: 1%;
    .itemUp {
      width: 100%;
      position: relative;
      float: left;
      cursor: pointer;
      .itemMar {
        margin-top: 100%;
      }
      .itemCen {
        width: 100%;
        height: 100%;
        float: left;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border: 1px solid #ddd;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .itemMor {
          width: 100%;
          height: 100%;
          float: left;
          position: relative;
          .upIco {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #ddd;
            font-size: 100px;
            z-index: 1;
          }
          .fileUp {
            position: absolute;
            width: 100%;
            height: 100%;
            float: left;
            font-size: 2px;
            opacity: 0;
            cursor: pointer;
            z-index: 2;
          }
        }
        .itemImg {
          width: 100%;
          height: 100%;
          background: #fff;
          z-index: 3;
          left: 0;
          top: 0;
          position: absolute;
          .imgBox {
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            position: relative;
            overflow: hidden;
            background-color: #ccc;
            border-radius: 10px;
            &:hover {
              .bg {
                top: 0;
              }
            }
            .bg {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 100%;
              left: 0;
              background: rgba(0, 0, 0, 0.7);
              z-index: 4;
              display: flex;
              justify-content: center;
              align-items: center;
              transition: 0.3s;
              .deleteIcon {
                font-size: 18px;
                color: #fff;
                z-index: 5;
              }
            }
            .imgShow {
              max-width: 100%;
              max-height: 100%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
    .top {
      font-weight: 900;
      margin-bottom: 10px;
    }
    .bottom {
      text-align: center;
      margin-top: 10px;
    }
  }
}
.container {
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 10px;
}
</style>
